import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatNum(v: string | number | null | undefined): string {
  if (v == null || v === '') return ''
  return Number(v).toLocaleString()
}

// 개수 단위(개·통·ea·pk·pck·팩·봉)에 자연수가 아닌 수량(0.5, 1.2 등)이 오면 오타 신호 →
// 화면·엑셀에서 수량에 노란 음영을 주기 위한 판별. ea/pk/pck 는 대소문자 무시.
const COUNT_UNITS = new Set(['개', '통', 'ea', 'pk', 'pck', '팩', '봉'])
export function isFractionalCountUnit(
  unit: string | null | undefined,
  qty: number | string | null | undefined,
): boolean {
  const u = (unit || '').trim().toLowerCase()
  if (!COUNT_UNITS.has(u)) return false
  const n = Number(qty)
  return Number.isFinite(n) && !Number.isInteger(n)
}

// 수량이 100 이상(절대값)이면 오타 신호 → 단위 무관하게 붉게 표시.
// 반품(음수) 큰 값도 잡히도록 절대값 기준.
export function isLargeQty(qty: number | string | null | undefined): boolean {
  const n = Number(qty)
  return Number.isFinite(n) && Math.abs(n) >= 100
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10)
}

export function firstOfMonthISO(): string {
  const d = new Date()
  d.setDate(1)
  return d.toISOString().slice(0, 10)
}
